module.exports = __webpack_public_path__ + "img/vmc_aniv16_24Aug2021.3e4b96be.jpg";